import React from 'react';

import { Form, Modal } from 'antd';
import { useWatch } from 'antd/es/form/Form';
import dayjs, { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'segments/hooks';
import { useNotification } from 'segments/hooks/useNotification';

import { InputStr, SubmiteButton } from 'shared/FormItems';
import { ModalFooter } from 'shared/Modals';

import { SelectBookingTime } from 'features/bookingTimeSelector';
import { selectBookingWaitTime, useCreateBookingWaitMutation } from 'features/bookingWait';
import { SelectUsers } from 'features/users';

type FormData = {
  startTime: Dayjs;
  endTime: Dayjs;
  note?: string;
  userId?: number;
}
interface Props {
  handleCancel: () => void;
}

export const CreateBookingWaitModal = ({ handleCancel }: Props) => {
  const { t } = useTranslation();

  const [createBookingWait, { isError, isLoading, isSuccess, error }] = useCreateBookingWaitMutation();
  const bookingStartTimeString = useAppSelector(selectBookingWaitTime);
  const bookingStartTime = bookingStartTimeString === null
    ? null
    : dayjs(bookingStartTimeString);
  const [form] = Form.useForm<FormData>();
  const formNote = useWatch('note', form);
  const formUserId = useWatch('userId', form);

  useNotification({
    isSuccess,
    isError,
    onSuccess: () => handleCancel(),
    onError: () => handleCancel(),
    error
  });

  const onFinish = ({ endTime, startTime, ...values }: FormData) => {
    createBookingWait({
      ...values,
      startTime: startTime.format('YYYY-MM-DDTHH:mm:ss'),
      endTime: endTime.format('YYYY-MM-DDTHH:mm:ss'),
    });
  };

  const validateFields = async () => {
    if (!formNote && !formUserId) {
      return Promise.reject(new Error('Выберите пользователя или добавьте заметку.'));
    }
    return Promise.resolve();
  };

  const modalTittle =
    `${t('booking-wait.title.create')}`;
  return (
    <Modal
      title={modalTittle}
      open
      onCancel={handleCancel}
      destroyOnClose
      footer={[
        <ModalFooter
          key="modalFooter"
          handleCancel={handleCancel}
          resetFields={form.resetFields}
        />
      ]}
    >
      <Form
        name="basic"
        layout="vertical"
        form={form}
        initialValues={{
          startTime: bookingStartTime,
          endTime: bookingStartTime?.add(1, 'hour')
        }}
        onFinish={onFinish}
        autoComplete="off"
        className="edit-user__form"
      >
        <SelectBookingTime form={form} showStartTime />
        <InputStr type='note' formProps={{ rules: [{ validator: validateFields }] }} />
        <SelectUsers oneSelectMode formProps={{ rules: [{ validator: validateFields }] }} />
        <SubmiteButton submiteText={t('table.booking')} isLoading={isLoading} />
      </Form>
    </Modal >
  );
};
